module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "connections",
    attrs: {
      "id": "game-content-connections"
    }
  }, [(_vm.hasData) ? _c('section', {
    staticClass: "panels"
  }, [_c('section', {
    staticClass: "panel"
  }, [(_vm.profileConnections.followers && _vm.profileConnections.followers.length > 0) ? _c('ul', {
    staticClass: "follows-list"
  }, _vm._l((_vm.profileConnections.followers), function(follower) {
    return _c('li', [_c('avatar', {
      attrs: {
        "profile-data": follower,
        "profile-type": "developer",
        "size": "small",
        "show-xp-info": true
      }
    }), _vm._v(" "), _c('router-link', {
      attrs: {
        "to": ("/Developer/" + (follower.stringUrl))
      }
    }, [_vm._v(_vm._s(follower.alias))])], 1)
  })) : _c('span', [_vm._v("No one is following " + _vm._s(_vm.profileAlias) + " yet.")])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a01845f6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Pages/Game/SubPages/GameFollowers.vue
// module id = 904
// module chunks = 2